import { CommonModule } from '@angular/common';
import { NgModule, inject } from '@angular/core';
import { Route } from '@angular/router';
import { MenuItem } from '@openng/optimus-ui/api';
import { AppTemplateModule } from '../app-template/app-template.module';
import { AppTab } from '../app-template/models/app-tab.model';
import { Config } from '../app-template/models/config.model';
import { PrimeModule } from '../prime/prime.module';
import { AdminPageDefinition } from '../sm-base/models/admin-page-definition.model';
import { FeatureModule } from '../sm-base/models/feature.module';
import { FeatureModuleService } from '../sm-base/services/feature-module.service';
import { SmBaseModule } from '../sm-base/sm-base.module';
import { AnonymousSearchComponent } from './components/anonymous-search/anonymous-search.component';
import { EnaioObjectComponent } from './components/enaio-object/enaio-object.component';
import { EnaioDocumentsDefinitionComponent } from './components/enaio-documents-definition/enaio-documents-definition.component';
import { EnaioDocumentsMainComponent } from './components/enaio-documents-main/enaio-documents-main.component';
import { EnaioDocumentsRoutingModule } from './enaio-documents-routing.module';

@NgModule({
    imports: [
        AppTemplateModule,
        CommonModule,
        SmBaseModule,
        PrimeModule
    ],
    declarations: [
        EnaioDocumentsDefinitionComponent,
        EnaioDocumentsMainComponent,
        EnaioObjectComponent,
        AnonymousSearchComponent
    ],
    exports: [
        EnaioDocumentsDefinitionComponent,
        EnaioObjectComponent
    ]
})
export class EnaioDocumentsModule implements FeatureModule {

    static mainBreadcrumb: MenuItem = null;

    featureModuleService = inject(FeatureModuleService);

    constructor() {
        this.featureModuleService.register(this);
    }

    getId(): string {
        return "EnaioDocumentsModule";
    }
    
    registerSidebar(model: AppTab[]): void {
        if (Config.get().isModuleConfigured(this.getId())) {
            model.push(new AppTab("documents", "Dokumente", "fas fa-file-text", 110, [], ["/enaio-documents", "home"]));
        }
    }

    async beforeAppStart(): Promise<void> {
    }

    async updateSidebarVisibility(_: AppTab[]): Promise<void> {
    }

    getMainRoute(): Route {
        return this.featureModuleService.createModuleRoute("enaio-documents", () => EnaioDocumentsRoutingModule);
    }

    getAdminPages(): AdminPageDefinition[] {
        return [];
    }
}